import React from "react";
import {
  Box,
  Typography,
  Grid,
  Button,
  Paper,
  IconButton,
} from "@mui/material";
import Reactimg from "../../assets/training/ImageReact.jpeg";
import img1 from "../../assets/training/light-removebg-preview.png";
import img2 from "../../assets/training/practice-removebg-preview.png";
import img3 from "../../assets/training/ask-removebg-preview.png";
import img4 from "../../assets/training/build-removebg-preview.png";

const Java = () => {
  const steps = [
    {
      img: img1,
      title: "Learn",
      color: "#ff0000",
      description:
        "Upskill yourself by gaining insights from leading professionals' vast experience.",
    },
    {
      img: img2,
      title: "Practice",
      color: "#ff0000",
      description:
        "Sharpen your skills by learning through course assignments, live projects, and regular assessments.",
    },
    {
      img: img3,
      title: "Ask",
      color: "#ff0000",
      description:
        "Engage in doubt-clearing sessions with industry experts to get answers to your questions.",
    },
    {
      img: img4,
      title: "Build",
      color: "#ff0000",
      description:
        "Make a compelling CV and a varied portfolio, and use LinkedIn to highlight your abilities.",
    },
  ];

  const benefits = [
    {
      number: "01",
      title: "Flexible Learning Schedule",
      description:
        "Fit your coursework around your existing commitments and obligations.",
    },
    {
      number: "02",
      title: "Expert Instructor",
      description:
        "Learn from industry experts who have hands-on experience in design and development.",
    },
    {
      number: "03",
      title: "Diverse Course Offerings",
      description:
        "Explore a wide range of design and development courses covering various topics.",
    },
    {
      number: "04",
      title: "Updated Curriculum",
      description:
        "Access courses with up-to-date content reflecting the latest trends and industry practices.",
    },
    {
      number: "05",
      title: "Practical Projects and Assignments",
      description:
        "Develop a portfolio showcasing your skills and abilities to potential employers.",
    },
    {
      number: "06",
      title: "Interactive Learning Environment",
      description:
        "Collaborate with fellow learners, exchanging ideas and feedback to enhance your understanding.",
    },
  ];
const features = [
    { title: "Duration", value: "2 Months" },
    { title: "Mode", value: "Online" },
    { title: "Projects", value: "4+" },
    { title: "Internship", value: "3/6 Months" },
  ];
  return (
    <Box sx={{ p: 4, backgroundColor: "#f5f5f5" }}>
      <Typography variant="h4" mb={2}>
        Our Training
      </Typography>

      {/* Demo Video
      <Box sx={{ maxWidth: 640, mx: "auto", mb: 4 }}>
  <iframe
    width="100%"
    height="360"
    src="https://www.youtube.com/embed/7tx0TX4Gp2Q" // Azure video ID
    title="Azure Introduction Video"
    frameBorder="0"
    allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
    allowFullScreen
    style={{ borderRadius: 8 }}
  ></iframe>
</Box> */}
      <Box sx={{ px: { xs: 2, md: 5 }, py: 5 }}>
        {/* Box 1: Main Course Description */}
        <Paper
          elevation={3}
          sx={{ p: { xs: 2, md: 4 }, mb: 4, borderRadius: 3 }}
        >
          <Typography variant="h5" fontWeight="bold" gutterBottom>
            Java Course
          </Typography>
          <Typography variant="body1">
            Do you want to make a rapid career change into web development and
            become a successful professional? Discover the perfect Java
            course with Esparse Matrix Solutions. Our all-inclusive training
            curriculum will teach you all you need to know to become an expert
            Java developer, and it's perfect for programmers, developers,
            and graduate students.
            <br />
            Use the Java courses offered by Esparse Matrix Solutions to hone
            your abilities as a web developer. You will learn what you need to
            know to create dynamic, effective web apps in our in-depth Java
            course. Come study front-end development with us and become an
            expert in the field with the help of our experienced instructors.
            Sign up with Esparse Matrix Solutions today to advance your Java
            knowledge.
          </Typography>
        </Paper>

        {/* Box 2: What is ReactJS + Image + Button */}
        <Paper
          elevation={3}
          sx={{ px: { xs: 2, md: 5 }, py: 5, borderRadius: 3 }}
        >
          <Grid container spacing={3} alignItems="center">
            {/* Text Section */}
            <Grid size={{ xs: 12, sm: 8, md: 8, lg: 8 }}>
              <Typography variant="h6" fontWeight="bold" gutterBottom>
                What is Java?
              </Typography>
              <Typography variant="body2" sx={{ mb: 3 }}>
                To construct user interfaces, developers often turn to the
                robust JavaScript framework known as Java. Experts Mode
                Solutions offer top-notch training and career guidance on React
                JS. From its basic concepts to advanced usage, this course will
                help you master this important library. Our Java curriculum
                includes components, hooks, state, and other top-level topics
                and implementation activities.
              </Typography>
              <Button
                variant="contained"
                sx={{
                  backgroundColor: "#c6f103",
                  color: "#000",
                  fontWeight: "bold",
                  textTransform: "none",
                  px: 3,
                  "&:hover": {
                    backgroundColor: "#b6e000",
                  },
                }}
              >
                Download Syllabus
              </Button>
            </Grid>

            {/* Image Section */}
            <Grid size={{ xs: 12, sm: 4, md: 4, lg: 4 }}>
              <Box
                component="img"
                src={Reactimg}
                alt="React Course"
                sx={{ width: "100%", borderRadius: 2, height: "200px" }}
              />
            </Grid>
          </Grid>
        </Paper>
      </Box>
      <Box sx={{ px: { xs: 2, md: 5 }, py: 5, backgroundColor: "#fff" }}>
        <Typography variant="h6" fontWeight="bold" gutterBottom sx={{ pl: 1 }}>
          How does this ReactJS Course work?
        </Typography>

        <Grid container spacing={3} justifyContent="center">
          {steps.map((step, index) => (
            <Grid size={{ xs: 12, sm: 3, md: 3, lg: 3 }} key={index}>
              <Paper
                elevation={2}
                sx={{
                  p: 3,
                  borderRadius: 2,
                  textAlign: "center",
                  border: "1px solid #ddd",
                  height: "100%",
                }}
              >
                <Box mb={2} display="flex" justifyContent="center">
                  <img
                    src={step.img}
                    alt={step.title}
                    style={{ width: 80, height: 80 }}
                  />
                </Box>
                <Typography
                  variant="subtitle1"
                  fontWeight="bold"
                  sx={{ color: "#e60000", mb: 1 }}
                >
                  {step.title}
                </Typography>
                <Typography variant="body2" color="textSecondary">
                  {step.description}
                </Typography>
              </Paper>
            </Grid>
          ))}
        </Grid>
      </Box>

      <Box sx={{ px: { xs: 2, md: 5 }, py: 6 }}>
        <Typography variant="h5" fontWeight="bold" gutterBottom sx={{ mb: 4 }}>
          Benefits
        </Typography>

        <Grid container spacing={3}>
          {benefits.map((item, index) => (
            <Grid size={{ xs: 12, sm: 4, md: 4, lg: 4 }} key={index}>
              <Paper
                elevation={0}
                sx={{
                  p: 3,
                  borderRadius: 3,
                  backgroundColor: "#fff",
                  height: "100%",
                  display: "flex",
                  flexDirection: "column",
                  justifyContent: "space-between",
                }}
              >
                <Box>
                  <Typography
                    variant="h4"
                    fontWeight="bold"
                    sx={{ color: "#111" }}
                  >
                    {item.number}
                  </Typography>
                  <Typography
                    variant="subtitle1"
                    fontWeight="bold"
                    sx={{ mt: 1 }}
                  >
                    {item.title}
                  </Typography>
                  <Typography variant="body2" sx={{ mt: 1, color: "#555" }}>
                    {item.description}
                  </Typography>
                </Box>

                <Box display="flex" justifyContent="flex-end" mt={2}>
                  <IconButton
                    sx={{
                      border: "1px solid #f0f0f0",
                      backgroundColor: "#fafafa",
                      borderRadius: 2,
                      width: 36,
                      height: 36,
                      "&:hover": { backgroundColor: "#f3f3f3" },
                    }}
                  >
                    <svg
                      width="10"
                      height="10"
                      viewBox="0 0 18 18"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        fill-rule="evenodd"
                        clip-rule="evenodd"
                        d="M1.20669 17.1266C1.70461 17.6245 2.51189 17.6245 3.00981 17.1266L15.2833 4.85312V14.525C15.2833 15.2292 15.8541 15.8 16.5583 15.8C17.2624 15.8 17.8333 15.2292 17.8333 14.525V1.775C17.8333 1.07084 17.2624 0.5 16.5583 0.5H3.80825C3.10409 0.5 2.53325 1.07084 2.53325 1.775C2.53325 2.47916 3.10409 3.05 3.80825 3.05H13.4801L1.20669 15.3234C0.708772 15.8214 0.708772 16.6286 1.20669 17.1266Z"
                        fill="#FF9500"
                      />
                    </svg>
                  </IconButton>
                </Box>
              </Paper>
            </Grid>
          ))}
        </Grid>
      </Box>
      <Box sx={{ px: { xs: 2, md: 5 }, py: 5, backgroundColor: "#fff" }}>
      <Typography variant="h6" fontWeight="bold" gutterBottom>
        What Will You Learn
      </Typography>
      <Typography variant="body2" sx={{ mb: 3 }}>
        A detailed overview of the course, including key topics, objectives, and module sequence.
      </Typography>

      <Grid container spacing={2}>
        {features.map((item, index) => (
          <Grid size={{ xs: 12, sm: 3, md: 3, lg: 3 }} key={index}>
            <Paper
              elevation={0}
              sx={{
                backgroundColor: "#e60000",
                color: "#fff",
                py: 2,
                borderRadius: 2,
                textAlign: "center",
              }}
            >
              <Typography variant="subtitle1" fontWeight="bold">
                {item.title}
              </Typography>
              <Typography variant="body2">{item.value}</Typography>
            </Paper>
          </Grid>
        ))}
      </Grid>
    </Box>
     <Box sx={{ px: { xs: 2, md: 5 }, py: 5 }}>
      <Paper elevation={0} sx={{ p: 3, borderRadius: 2 }}>
        <Grid container spacing={4} alignItems="center">
          {/* Text */}
          <Grid size={{ xs: 12, sm: 6, md: 6, lg: 6 }}>
            <Typography  fontWeight="bold" sx={{ mb: 2 }}>
              <span style={{ fontWeight: 800 , fontSize:"40px", textAlign:"center"}}>
                Get a <strong>one-stop solution</strong> for all the training needs
                required to fulfill your dream job.
              </span>
            </Typography>
            <Typography variant="body2" color="text.secondary">
              Discover comprehensive training solutions to help you achieve your
              dream job in software industry. Our expert-led courses cover
              everything you need to succeed in the industry.
            </Typography>
          </Grid>

          {/* Image Placeholder */}
         
        </Grid>
      </Paper>
    </Box>
    </Box>
  );
};

export default Java;